import { generateUUID } from 'common/utils/utils';

export default function defaultAddress(address = { is_primary: false }) {
  return {
    id: generateUUID(),
    ...address,
  };
}
